var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.82 33.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-B4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.24,18.58l-8-6.45c-.57-.46-1.75-.21-1.73.54,0,1.71-.13,8.11,0,13.1,0,.67,1.14,1,1.75.52l8-6.46A.78.78,0,0,0,21.24,18.58Z",
    transform: "translate(0 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.37,5.36a14.3,14.3,0,0,0-3.84-.52A14.53,14.53,0,1,0,28.86,17a9.67,9.67,0,0,1-1.53.13H27a13.27,13.27,0,0,1,.2,2.29A12.65,12.65,0,1,1,14.53,6.72a12.5,12.5,0,0,1,3.53.51,9.49,9.49,0,0,1,.31-1.87Z",
    transform: "translate(0 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.24,7.56a4.51,4.51,0,0,0,0-1.34L34.7,5.08a.35.35,0,0,0,.08-.44L33.4,2.26a.35.35,0,0,0-.3-.18.21.21,0,0,0-.12,0l-1.72.68a4.94,4.94,0,0,0-1.16-.67L29.84.29A.35.35,0,0,0,29.5,0H26.74a.34.34,0,0,0-.34.29l-.26,1.83A5.63,5.63,0,0,0,25,2.79l-1.71-.68a.31.31,0,0,0-.13,0,.35.35,0,0,0-.29.18L21.46,4.64a.34.34,0,0,0,.08.44L23,6.22c0,.22,0,.44,0,.67s0,.46,0,.67L21.54,8.7a.35.35,0,0,0-.08.45l1.38,2.38a.34.34,0,0,0,.3.17l.12,0L25,11a5.26,5.26,0,0,0,1.17.68l.26,1.82a.34.34,0,0,0,.34.29H29.5a.34.34,0,0,0,.34-.29l.26-1.82A5.6,5.6,0,0,0,31.26,11l1.72.69.12,0a.34.34,0,0,0,.3-.17l1.38-2.38a.36.36,0,0,0-.08-.45L33.24,7.56ZM31.87,6.38a3.53,3.53,0,0,1,0,.51,3.41,3.41,0,0,1,0,.5l-.09.78.61.48.75.58-.48.83-.88-.35-.72-.29-.62.47a4.32,4.32,0,0,1-.86.5l-.73.3-.11.78-.14.93h-1l-.13-.93-.11-.78-.73-.3a3.47,3.47,0,0,1-.85-.49l-.63-.48-.73.3-.88.35-.48-.83.74-.58.62-.48-.1-.78c0-.22,0-.37,0-.51s0-.3,0-.51l.1-.77-.62-.49-.74-.58.48-.83.88.36.72.28.62-.47a4.32,4.32,0,0,1,.86-.5l.73-.3.11-.77.13-.94h1l.13.94.11.77.73.3a3.82,3.82,0,0,1,.85.49l.63.48.73-.29.88-.36.48.84-.74.58-.61.49ZM28.12,4.13a2.76,2.76,0,1,0,2.76,2.76A2.76,2.76,0,0,0,28.12,4.13Zm0,4.14A1.38,1.38,0,1,1,29.5,6.89,1.38,1.38,0,0,1,28.12,8.27Z",
    transform: "translate(0 0)",
    fill: "#4d4d4d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB4);
export default __webpack_public_path__ + "static/media/B4.21a29ad61993c3fdff5ac36991aa4bcb.svg";
export { ForwardRef as ReactComponent };